<template>
  <l-map style="height: 80vh; z-index:0" :zoom="zoom" :center="center" :minZoom="minZoom" :maxZoom="maxZoom" :max-bounds="maxBounds">
    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
    <l-marker :key="index" v-for="(brew, index) in marker" :lat-lng="[brew.lat, brew.lon]"></l-marker>
  </l-map>
</template>

<script>
import { LMap, LTileLayer, LMarker, LIcon } from "vue2-leaflet";
import { latLngBounds } from "leaflet";

export default {
  name: "Example",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
  },
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 4,
      markerLatLng: [0, 0],
      marker:[],
      iconSize: 64,
      maxZoom: 15,
      minZoom: 5, //3
            maxBounds: latLngBounds([
        [12.803612514714583, 89.69673251106663],
        [-15.82917931108562, 152.16775220869806],
      ]),      
      center: [-1.949497, 120.9731265],
    };
  },

  computed: {
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15];
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15];
    },
  },
  mounted() {
    this.getlatlon()
    // const success = (position) => {
    //   const latitude = position.coords.latitude;
    //   const longitude = position.coords.longitude;
    //   // this.center = [latitude, longitude];
    //   this.markerLatLng = [latitude, longitude];
    //   // Do something with the position
    // };

    // const error = (err) => {
    //   console.log(error);
    // };

    // // This will open permission popup
    // navigator.geolocation.getCurrentPosition(success, error);
  },
  methods: {
    getlatlon() {
      this.axios
        .get(`${process.env.VUE_APP_API}/api/users/latlon`)
        .then((response) => {
          const payload = response.data;
          console.log(payload.data);
          this.marker = payload.data;
        });
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    innerClick() {
      alert("Click!");
    },
  },
};
</script>